module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"inviteEmployee":"Convidar usuário Employee","inviteSetAsEmployee":"Atribuir permissão Employee"},"en-US":{"inviteEmployee":"Invite Employee User","inviteSetAsEmployee":"Assign Employee Permission"}}')
  delete Component.options._Ctor
}
